import { UserContext } from '@providers/userContextProvider';
import dayjs from 'dayjs';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryBuilder } from '../utils';
import { NumberWidget } from './numberWidget';

const totalUsersQuery = (activeOrganization: any, funded: boolean) => ({
  filters: [
    {
      field: 'organization',
      comparison: 'EQUALS',
      value: activeOrganization.id,
    },
    ...(funded
      ? [
          {
            field: 'marketValueCents',
            comparison: 'GREATER_THAN',
            value: '0',
          },
        ]
      : []),
    {
      field: 'state',
      comparison: 'EQUALS',
      value: 'ACTIVE',
    },
  ],
  type: 'USER',
  grouping: {
    field: null,
    interval: null,
    type: 'SINGLE_VALUE',
    valueAggregation: 'VALUE_COUNT',
    valueField: 'id',
  },
});

const historyUsersQuery = (activeOrganization: any, funded: boolean) => ({
  filters: [
    {
      field: 'organization',
      comparison: 'EQUALS',
      value: activeOrganization.id,
    },
    ...(funded
      ? [
          {
            field: 'marketValueCents',
            comparison: 'GREATER_THAN',
            value: '0',
          },
        ]
      : []),
    {
      field: 'state',
      comparison: 'EQUALS',
      value: 'ACTIVE',
    },
    {
      field: 'createdAt',
      comparison: 'LESS_THAN',
      value: dayjs().startOf('month').format('YYYY-MM-DD'),
    },
  ],
  type: 'USER',
  grouping: {
    field: null,
    interval: null,
    type: 'SINGLE_VALUE',
    valueAggregation: 'VALUE_COUNT',
    valueField: 'id',
  },
});

export const TotalUsers = ({ funded }: { funded: boolean }) => {
  const { activeOrganization } = useContext(UserContext);
  const { t } = useTranslation('homePageConfiguration');
  const [totalUsers, setTotalUsers] = useState<number>(1);
  const [historyUsers, setHistoryUsers] = useState<number>(1);
  const { data: totalUsersData, loading: totalUsersLoading } = useQueryBuilder(
    totalUsersQuery(activeOrganization, funded),
  );
  const { data: historyUsersData, loading: historyUsersLoading } =
    useQueryBuilder(historyUsersQuery(activeOrganization, funded));

  useEffect(() => {
    if (totalUsersData?.generateReport?.grouping) {
      setTotalUsers(totalUsersData?.generateReport?.grouping.value ?? 1);
    }
    if (historyUsersData?.generateReport?.grouping) {
      setHistoryUsers(historyUsersData?.generateReport?.grouping.value ?? 1);
    }
  }, [totalUsersData, historyUsersData]);

  return (
    <NumberWidget
      title={t(`practiceOverview.${funded ? 'fundedClients' : 'totalClients'}`)}
      newValue={totalUsers}
      oldValue={historyUsers}
      loading={totalUsersLoading || historyUsersLoading}
      isCurrency={false}
    />
  );
};
